import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Sociallinks.css"; // Your custom CSS file

const SocialLinks = () => {
  const [fetchedData, setFetchedData] = useState([]);
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [twitter, setTwitter] = useState("");
  const [youtube, setYoutube] = useState("");

  const fetchData = async () => {
    try {
      const { data } = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Sociallinks"
      );

      // Process the data to set the respective URLs
      data.forEach((item) => {
        const lowerTitle = item.title.toLowerCase();

        if (lowerTitle === "facebook" && item.url) {
          setFacebook(`https://${item.url}`); // Ensure URL includes https://
        }

        if (lowerTitle === "instagram" && item.url) {
          setInstagram(`https://${item.url}`);
        }

        if (lowerTitle === "twitter" && item.url) {
          setTwitter(`https://${item.url}`);
        }
        if (lowerTitle === "youtube" && item.url) {
          setYoutube(`https://${item.url}`);
        }
      });

      setFetchedData(data); // If needed for debugging or further processing
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log(fetchedData);

  return (
    <div className=" social-links-box container mt-5">
      <div className="row justify-content-center">
        <h3 className="col-12 text-center social-links-title">Follow Us</h3>
        <div
          className="col-12 col-md-4 d-flex justify-content-around"
          style={{ marginBottom: "10px" }}
        >
          <a
            href={facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon facebook"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          <a
            href={instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href={twitter}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon twitter"
          >
            <i className="fab fa-twitter"></i>
          </a>
          <a
            href={youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SocialLinks;
